import React from 'react';
export const UnitWrapper: React.FC<{ unit: string; type: string | undefined; activeSOS: boolean }> = ({
    unit,
    type,
    activeSOS
}) => {
    return (
        <span style={{ color: activeSOS ? 'inherit' : '#8C8C8C' }}>
            {unit} <span style={{ fontSize: 'xx-small' }}>{type}</span>
        </span>
    );
};